import { render, staticRenderFns } from "./product.vue?vue&type=template&id=7f1b3598"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=7f1b3598&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f1b3598')) {
      api.createRecord('7f1b3598', component.options)
    } else {
      api.reload('7f1b3598', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=7f1b3598", function () {
      api.rerender('7f1b3598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/suppliers/fields/product.vue"
export default component.exports